import { CapoPlugin } from "/Users/ted/workspace/rphq/rphq-redpoint-api-v1/cpx/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];